const setCachevalue = (value, key) => {
    sessionStorage.setItem(key,value);
}
const getCachevalue = (key) => {
    let value = sessionStorage.getItem(key);
    return value;
}
const clearCachevalue = (key) => {
    sessionStorage.removeItem(key);
}
const clearAllCachevalue = () => {
    sessionStorage.clear();
}
const localSetItem = (key, value) =>{
    return localStorage.setItem(key, value);
}
const localGetItem = (key) =>{
    return localStorage.getItem(key);
}

const getClinicIdWithContext = (existing) => {
    if (existing !== null && existing !== undefined) {
        return existing
    }
    const sessionClinic = getCachevalue('SelectedDoctorClinic')
    if (sessionClinic != null) return sessionClinic
    const localClinic = localGetItem('SelectedDoctorClinicId')
    if (localClinic != null) return localClinic
    try {
        const raw = localGetItem('loggedInUserInfo')
        if (!raw) return null
        const user = JSON.parse(raw)
        return user?.clinic_id ?? null
    } catch (_) {
        return null
    }
}

const getSpecializationIdWithContext = (existing) => {
    if (existing !== null && existing !== undefined) {
        return existing
    }
    try {
        const patientRaw = getCachevalue('DoctorPatientData')
        if (patientRaw) {
            const patient = JSON.parse(patientRaw)
            const sid =
                patient?.speciality_id ??
                patient?.specialization_id ??
                patient?.doctor_speciality
            if (sid !== null && sid !== undefined) {
                return sid
            }
        }
    } catch (_) {}
    try {
        const raw = localGetItem('loggedInUserInfo')
        if (!raw) return null
        const user = JSON.parse(raw)
        return user?.specialization_id ?? null
    } catch (_) {
        return null
    }
}

const localClearItem = (key) => {
    return localStorage.removeItem(key);
}
const localClearAll = () =>{
    return localStorage.clear();
}
export { setCachevalue, getCachevalue, clearCachevalue, clearAllCachevalue, localSetItem, localGetItem, localClearItem, localClearAll, getClinicIdWithContext, getSpecializationIdWithContext }